module.exports = ['$scope', '$timeout', 'locale', function($scope, $timeout, locale) {
  // Holds data from the Countries select box form
  this.otherCitizenship = '';
  // Holds the array of Citizenship objects: {code, name}
  this.citizenships = [];
  // Checks if the $watch statement is being run on initial load or from user input
  let doneOnce = false;
  // Whether to show the pills container or not
  this.showPills = false;

  // Adds the initial pills from the server, when the page first loads
  $scope.addCountries = (citizenshipArray) => {
    if(citizenshipArray && Array.isArray(citizenshipArray)) {
      this.citizenships = citizenshipArray;
      $scope.model = this.citizenships.map((country) => country.code);
      this.showPills = true;
    } else {
      this.citizenships = [];
      $scope.model = null;
      this.showPills = false;
    }
  }

  // When the select box value changes, update the list of pills
  $scope.$watch('ctrl.otherCitizenship', (value) => {
    // If the select box returns a value, and it's not in the list, add it to the list of pills
    if(value && (this.citizenships.length < 1 || this.citizenships.filter((country) => country.code === value.code).length < 1)) {
      this.citizenships.push(value);
    }
    if(this.citizenships.length) {
      $scope.model = this.citizenships.map((country) => country.code); 
      this.showPills = true;
    } else if(doneOnce) {
      $scope.model = null;
      this.showPills = false;
    } else {
      doneOnce = true;
    }
    setTimeout(() => {
      this.otherCitizenship = '';
    }, 1000);
  })

  // Remove pill from list, and update form to say a change was made.
  $scope.remove = (code) => {
    this.citizenships = this.citizenships.filter((country) => country.code !== code);
    // A bit of a hack to access the form
    $scope.$parent.$parent.$parent.$parent.$parent.wrapper.profileForm.$setDirty(true);
    // Check if we have any pills to show, and if so, show them
    if(this.citizenships.length) {
      $scope.model = this.citizenships.map((country) => country.code);
      this.showPills = true;
    // Otherwise, hide the pills container
    } else {
      $scope.model = null;
      this.showPills = false;
    }
  }

  return this;
}];
